import {
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import ResizeObserver from 'resize-observer-polyfill';

export class ResizedEvent {
  constructor(
    readonly element: ElementRef,
    readonly newWidth: number,
    readonly newHeight: number,
    readonly oldWidth: number,
    readonly oldHeight: number
  ) {}
}

@Directive({
  standalone: false,
  // tslint:disable-next-line:directive-selector
  selector: '[dauiResize]',
})
export class ResizeDirective implements OnInit, OnDestroy {
  @Output('dauiResize')
  readonly resized = new EventEmitter<ResizedEvent>();

  oldWidth: number;
  oldHeight: number;
  resizeObserver: ResizeObserver;

  constructor(private readonly element: ElementRef) {}

  ngOnInit(): void {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.contentRect) {
          this.onResized();
        }
      }
    });

    this.resizeObserver.observe(this.element.nativeElement);
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.element.nativeElement);
    }
  }

  private onResized(): void {
    const width = this.element.nativeElement.clientWidth;
    const height = this.element.nativeElement.clientHeight;

    if (width === this.oldWidth && height === this.oldHeight) {
      return;
    }

    const event = new ResizedEvent(
      this.element,
      width,
      height,
      this.oldWidth,
      this.oldHeight
    );

    this.oldWidth = this.element.nativeElement.clientWidth;
    this.oldHeight = this.element.nativeElement.clientHeight;

    this.resized.emit(event);
  }
}
